import { getFormattedLink } from "src/helpers/utils";
import { ECONTACT_TYPE } from "./SourceAddContactDetailsModal";
import clsx from "clsx";
import { CONTACT_DEFAULT_ICONS, ICON_SIZES } from "src/helpers/constants";
import Icon from "src/components/Icon/Icon";
import { AnimatePresence, motion } from "framer-motion";
import ButtonGroup from "src/components/ButtonGroup/ButtonGroup";
import { MdDelete, MdEdit } from "react-icons/md";
import { IButton } from "src/components/Button/Button";
import { EButtonKind } from "src/components/Button/ButtonTypes";
import ConfirmDialog from "src/components/ConfirmDialog/ConfirmDialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface ISourcesContactCards {
  items: any[];
  columns?: number;
  onDelete: (data: any) => void;
  onEdit: (data: any) => void;
}

const SourcesContactCards: React.FC<ISourcesContactCards> = ({
  items,
  columns = 1,
  onDelete,
  onEdit,
}) => {
  const { t } = useTranslation();
  const [indexToEditOrDelete, setIndexToEditOrDelete] = useState<number | null>(
    null
  );
  const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);
  if (!items?.length) return null;

  return (
    <>
      <div
        className={clsx([
          "grid",
          "grid-cols-1",
          `md:grid-cols-${columns}`,
          {
            // "md:grid-cols-2": items?.length > 1,
          },
          "gap-2",
          "md:gap-2",
          "w-full",
        ])}
      >
        <AnimatePresence mode="wait">
          {items?.map?.((data: any, key: number) => {
            return (
              <motion.a
                key={key}
                className={clsx([
                  "flex",
                  "flex-row",
                  "w-full",
                  "bg-blue-100/60 dark:bg-gray-900/50",
                  "p-2 md:p-4",
                  "rounded-md",
                  "md:gap-4",
                  "gap-2",
                  "md:text-base",
                  "text-sm",
                ])}
                href={getFormattedLink({
                  type: data?.type,
                  value: data?.value,
                })}
                target={data?.type === ECONTACT_TYPE.LINK ? "_blank" : ""}
                initial={{
                  opacity: 0,
                  x: key % 2 === 0 ? -100 : 100,
                }}
                animate={{ opacity: 1, x: 0 }}
                transition={{
                  duration: 0.3,
                  ease: "easeOut",
                  delay: key * 0.1,
                }}
              >
                <div
                  className={clsx([
                    "flex",
                    "flex-row",
                    "gap-2",
                    "md:gap-4",
                    "flex-grow",
                    "flex-shrink",
                    "truncate",
                  ])}
                >
                  <div>
                    <Icon
                      name={
                        data?.icon ||
                        CONTACT_DEFAULT_ICONS[data?.type as ECONTACT_TYPE]
                      }
                      size={ICON_SIZES.LG}
                      className={clsx(["dark:text-cyan-400", "text-blue-400"])}
                    />
                  </div>
                  <div className={clsx(["truncate"])}>
                    <div>{data?.name || "Sin nombre"}</div>
                    <div className={clsx(["truncate"])}>{data?.value}</div>
                  </div>
                </div>
                <div
                  onClick={(e) => {
                    e.stopPropagation?.();
                    e?.preventDefault?.();
                  }}
                >
                  <ButtonGroup
                    buttons={[
                      {
                        icon: <MdDelete size={ICON_SIZES.MD} />,
                        kind: EButtonKind.DANGER,
                        onClick: (e: any) => {
                          e.stopPropagation();
                          e.preventDefault();

                          setIndexToEditOrDelete(key);
                          setShowDeleteDialog(true);
                          // onDelete(key);
                        },
                      },
                      {
                        icon: <MdEdit size={ICON_SIZES.MD} />,
                        kind: EButtonKind.EDIT,
                        onClick: (e: any) => {
                          e.stopPropagation();
                          e.preventDefault();
                          onEdit({ index: key, name: "" });
                        },
                      },
                    ]}
                  />
                </div>
              </motion.a>
            );
          })}
        </AnimatePresence>
      </div>
      {showDeleteDialog && (
        <ConfirmDialog
          onClose={() => {
            setIndexToEditOrDelete(null);
            setShowDeleteDialog(false);
          }}
          description="¿Deseas eliminar la información de contacto?"
          title={t("common_dialog_titles.delete")}
          doubleConfirmRequired
          onConfirm={() => onDelete({ index: indexToEditOrDelete })}
          confirmKind={EButtonKind.DANGER}
        />
      )}
    </>
  );
};

export default SourcesContactCards;
